import { Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { finalize } from 'rxjs/operators';
import { LaravelResourceResponse } from '../../../../../../../../_base-shared/contracts/laravel-response.interface';
import { Case } from '../../../../../../../../_base-shared/models/Case/Case';
import { Settlement } from '../../../../../../../../_base-shared/models/Case/Settlement';
import { CaseService } from '../../../case.service';

@Component({
  standalone: false,
  selector:    'app-case-settlement-list',
  templateUrl: './case-settlement-list.component.html',
  styles:      [],
})
export class CaseSettlementListComponent implements OnInit {
  @Input() case: Case;

  private readonly caseService = inject(CaseService);

  public readonly isLoading      = signal(0);
  public readonly serverResponse = signal<LaravelResourceResponse | null>(null);
  public readonly dataSource     = signal(new MatTableDataSource<Settlement>([]));
  public readonly paginatorConfig = signal({pageIndex: 0, pageSize: 10, length: 1});

  public readonly hasData      = computed(() => this.dataSource().data.length > 0);
  public readonly displayedColumns: string[] = [
    'created_at', 'creditor', 'debt_amount', 'settled_amount', 'percent_reduction',
  ];

  ngOnInit(): void {
    this.fetchSettlements();
  }

  private fetchSettlements(): void {
    this.isLoading.update(v => v + 1);
    this.dataSource.set(new MatTableDataSource<Settlement>([]));

    const {pageIndex, pageSize} = this.paginatorConfig();

    this.caseService.getSettlements(this.case.id, {per_page: pageSize, page: pageIndex + 1})
      .pipe(finalize(() => this.isLoading.update(v => v - 1)))
      .subscribe({
        next:  result => {
          this.dataSource.set(new MatTableDataSource<Settlement>(result.data));
          this.paginatorConfig.update(c => ({...c, length: result.meta.total}));
        },
        error: err => this.serverResponse.set(err.error),
      });
  }

  public paginatorChange($event: PageEvent): void {
    this.paginatorConfig.update(c => ({
      ...c,
      pageIndex: $event.pageIndex,
      pageSize:  $event.pageSize,
      length:    $event.length,
    }));
    this.fetchSettlements();
  }
}
